import { ProductApi } from '@core/api'
import { RequestStatus } from '@/libs/product'
import { clearCachedReceivedRequest } from '@core/domain/product'

export default {
    methods: {
        sendReply() {
            this.showLoading = true
            const declaration = this.makeDeclaration()
            const replyRequest = this.selectedBulkReplyRequestIds.length > 0
                ? ProductApi.replyToRequestBulk(
                    this.id,
                    declaration,
                    this.selectedBulkReplyRequestIds,
                )
                : ProductApi.replyToRequest(this.id, declaration)

            return replyRequest
                .then(() => {
                    this.request.status = RequestStatus.REPLIED
                    this.$swal({
                        title: this.$t('Page(ReceivedRequest):Component(SendReplyAck):title'),
                        text: this.$t('Page(ReceivedRequest):Component(SendReplyAck):text'),
                        icon: 'success',
                        timer: 1300,
                        allowOutsideClick: true,
                        customClass: { confirmButton: 'btn btn-primary' },
                        buttonsStyling: false,
                    })
                    clearCachedReceivedRequest(this.id)
                    return this.fetchProductRequest().then(request => {
                        this.request = request.request
                    })
                })
                .catch(this.handleBackendError)
                .finally(() => {
                    this.showLoading = false
                })
        },
    },
}
